import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueToast)

Vue.filter('numberSeperator', function (value) {
    if(typeof value != 'undefined' && value != null){
        return value.toString().replace(/\D/g,'').replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")
    }else{
        return value
    }
})
Vue.filter('numberSeperatorWhiteKG', function (value) {
    if(typeof value != 'undefined' && value != null){
        return value.toString().replace(/\D/g,'').replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ") + " kg"
    }else{
        return value
    }
})

Vue.config.productionTip = false

new Vue({
    el: '#app',
    components: {
        LoginScreen: () =>
            import(
                /* webpackChunkName: 'LoginScreen' */
                './components/LoginScreen/LoginScreen.vue'
            ),
        Navigation: () =>
            import(
                /* webpackChunkName: 'Navigation' */
                './components/Navigation/Navigation.vue'
            ),
        Navbar: () =>
            import(
                /* webpackChunkName: 'Navbar' */
                './components/Navbar/Navbar.vue'
            ),
        Breadcrumb: () =>
            import(
                /* webpackChunkName: 'Breadcrumb' */
                './components/Breadcrumb/Breadcrumb.vue'
            ),
        FormCreator: () =>
            import(
                /* webpackChunkName: 'FormCreator' */
                './components/FormCreator/FormCreator.vue'
            ),
        DataTable: () =>
            import(
                /* webpackChunkName: 'DataTable' */
                './components/DataTable/DataTable.vue'
            ),
        Settings: () =>
            import(
                /* webpackChunkName: 'Settings' */
                './components/Settings/Settings.vue'
            ),
        MasterData: () =>
            import(
                /* webpackChunkName: 'MasterData' */
                './components/MasterData/MasterData.vue'
            ),
        Accordion: () =>
            import(
                /* webpackChunkName: 'Accordion' */
                './components/Accordion/Accordion.vue'
            ),
        ShippingAddresses: () =>
            import(
                /* webpackChunkName: 'ShippingAddresses' */
                './components/ShippingAddresses/ShippingAddresses.vue'
            ),
        OrderCreator: () =>
            import(
                /* webpackChunkName: 'OrderCreator' */
                './components/OrderCreator/OrderCreator.vue'
            ),
        TransportersEditor: () =>
            import(
                /* webpackChunkName: 'TransportersEditor' */
                './components/TransportersEditor/TransportersEditor.vue'
            ),
        ShippingCreator: () =>
            import(
                /* webpackChunkName: 'ShippingCreator' */
                './components/ShippingCreator/ShippingCreator.vue'
            ),
        FuelTransports: () =>
            import(
                /* webpackChunkName: 'FuelTransports' */
                './components/FuelTransports/FuelTransports.vue'
            ),
        TransportersDashboard: () =>
            import(
                /* webpackChunkName: 'TransportersDashboard' */
                './components/dashboard-elements/TransportersDashboard.vue'
            ),
        TransportersManagerDashboard: () =>
            import(
                /* webpackChunkName: 'TransportersManagerDashboard' */
                './components/dashboard-elements/TransportersManagerDashboard.vue'
            ),
        PartnersDashboard: () =>
            import(
                /* webpackChunkName: 'PartnersDashboard' */
                './components/dashboard-elements/PartnersDashboard.vue'
            ),
        AdminDashboard: () =>
            import(
                /* webpackChunkName: 'AdminDashboard' */
                './components/dashboard-elements/AdminDashboard.vue'
            ),
        OrderManagerDashboard: () =>
            import(
                /* webpackChunkName: 'OrderManagerDashboard' */
                './components/dashboard-elements/OrderManagerDashboard.vue'
            ),
        CoverageStatistics: () =>
            import(
                /* webpackChunkName: 'CoverageStatistics' */
                './components/dashboard-elements/CoverageStatistics/CoverageStatistics.vue'
            ),
        NumberOfShipmentsStatistics: () =>
            import(
                /* webpackChunkName: 'NumberOfShipmentsStatistics' */
                './components/dashboard-elements/NumberOfShipmentsStatistics/NumberOfShipmentsStatistics.vue'
            ),
        MessageWall: () =>
            import(
                /* webpackChunkName: 'MessageWall' */
                './components/dashboard-elements/MessageWall/MessageWall.vue'
            ),
        AcceptLegalStatements: () =>
            import(
                /* webpackChunkName: 'AcceptLegalStatements' */
                './components/AcceptLegalStatements/AcceptLegalStatements.vue'
            ),
    },
    methods: {
    },
    data:{
        accordion : 0
    }
})
